import { brandConfig } from '../config';

const dateTimezone = (date: string | number | Date, timezone: string = brandConfig.timezone) =>
  date instanceof Date
    ? new Date(date.toLocaleString('en-US', { timeZone: timezone }))
    : new Date(new Date(date).toLocaleString('en-US', { timeZone: timezone }));
export default dateTimezone;
